import { LoadableApp } from 'ui-seeker/core'
import { RE_HOTELS, RE_RESTAURANTS, RE_RESOURCES } from 'app/config'

const Hotels = LoadableApp(import('./Hotels'))
const Restaurants = LoadableApp(import('./Restaurants'))
const Resources = LoadableApp(import('./Resources'))

const PageRoutes = [
    { path: RE_HOTELS.path, component: Hotels, needLogin: true, header: false },
    { path: RE_RESTAURANTS.path, component: Restaurants, needLogin: true, header: true },
    { path: RE_RESOURCES.path, component: Resources, needLogin: true, header: false },
]

export default PageRoutes